var _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup70({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 60.0001,
    cy: 39.8706,
    rx: 39.8705,
    ry: 39.8705,
    transform: "rotate(180 60.0001 39.8706)",
    fill: "#FCE400"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    rx: 39.8705,
    ry: 39.8705,
    transform: "matrix(1 0 0 -1 59.9999 80.1294)",
    fill: "#FCE400"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 80.1295,
    cy: 60.0001,
    rx: 39.8705,
    ry: 39.8705,
    transform: "rotate(-90 80.1295 60.0001)",
    fill: "#FCE400"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    rx: 39.8705,
    ry: 39.8705,
    transform: "matrix(-5.94576e-08 1 1 3.21352e-08 39.8705 60)",
    fill: "#FCE400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup70);
export default __webpack_public_path__ + "static/media/Group 70.48595c6554f83aa135270a7808e97e82.svg";
export { ForwardRef as ReactComponent };